import { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom';

import {
  logException,
  initIfEnabled as initSentryIfEnabled,
} from '@sureapp/wl-toggle-common/dist/services/sentry';
import analytics from '@sureapp/wl-toggle-common/dist/utils/analytics';
import { Route, Switch, BrowserRouter as Router } from 'react-router-dom';

import { initIfEnabled as initLogRocketIfEnabled } from '@@/auto/utils/logRocket';

import SpinnerView from './auto/components/SpinnerView';
import './index.css';
import type { IWindow } from './auto/interfaces/window.interface';
import { isProductionEnvironment } from './auto/services/isEnvironment';

declare global {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  interface Window extends IWindow {}
}

const App = lazy(() => import('./components/App'));

// A namespace for the team to store small helper functions or values.
window.tauto = window.tauto ?? {};

/*
 * Configure third-party
 */
if (isProductionEnvironment()) {
  initSentryIfEnabled();
  initLogRocketIfEnabled();

  if (process.env.REACT_APP_SEGMENT_WRITE_KEY) {
    analytics.load(process.env.REACT_APP_SEGMENT_WRITE_KEY);
  }

  setTimeout(() => {
    const s = document.createElement('script');
    s.id = 'ze-snippet';
    s.src = `https://static.zdassets.com/ekr/snippet.js?key=${process.env.REACT_APP_ZENDESK_KEY}`;
    s.onerror = logException;
    document.head.appendChild(s);
  }, 2500);
}

/**
 * Mount the app in standalone mode
 */
if (process.env.REACT_APP_STANDALONE === 'true') {
  ReactDOM.render(
    <Router>
      <Suspense fallback={<SpinnerView data-testid="App_spinner" />}>
        <Switch>
          <Route component={App} />
        </Switch>
      </Suspense>
    </Router>,
    document.getElementById('root')
  );
}

export default function Root() {
  return (
    <Router>
      <Suspense fallback={<SpinnerView data-testid="App_spinner" />}>
        <Switch>
          <Route component={App} />
        </Switch>
      </Suspense>
    </Router>
  );
}
